// extracted by mini-css-extract-plugin
export var announcement = "styles-module--announcement--EsjB7";
export var strong = "styles-module--strong--3Nz4w";